export const appMsg = (share) => {
  if (window.MaiMai_Native && window.MaiMai_Native.appMsg) {
    window.MaiMai_Native.appMsg(JSON.stringify(share));
  }
};

/**
 * 隐藏APP顶部白条
 */
export const hideAppHead = () => {
  if (window.MaiMai_Native && window.MaiMai_Native.native_set_navigationbar_v2) {
    // title bar 透明
    window.MaiMai_Native.native_set_navigationbar_v2(true, '', '', 1);
  } else if (window.MaiMai_Native && window.MaiMai_Native.native_set_navigationbar) {
    window.MaiMai_Native.native_set_navigationbar(true, '', '');
  }
};

export const closePage = (tips = '', flag = true) => {
  if (window.MaiMai_Native && window.MaiMai_Native.close_native) {
    window.MaiMai_Native.close_native(tips, flag);
  }
};

export const openPage = (url = '', title = '') => {
  if (window.MaiMai_Native && window.MaiMai_Native.native_open_new_webview) {
    window.MaiMai_Native.native_open_new_webview(url, title);
  } else {
    window.location.href = url;
  }
};

export const openPage2 = (url: string, data?: any, callback?: () => void) => {
  if (window.MaiMai_Native && window.MaiMai_Native.native_open_schema_v2) {
    window.MaiMai_Native.native_open_schema_v2(url, data, callback);
  } else {
    window.location.href = url;
  }
};

export const hideHeader = () => {
  if (window.MaiMai_Native && window.MaiMai_Native.native_set_navigationbar_v2) {
    window.MaiMai_Native.native_set_navigationbar_v2(true, '', '', false);
  } else if (window.MaiMai_Native && window.MaiMai_Native.native_set_navigationbar) {
    window.MaiMai_Native.native_set_navigationbar(true, '', '');
  }
};

export const nativeChat = (u2) => {
  if (window.MaiMai_Native && window.MaiMai_Native.native_chat) {
    window.MaiMai_Native.native_chat('', u2);
  }
};

export const switchLockScroll = (type = true) => {
  const root = document.getElementById('root');
  const style = document.createElement('style');

  style.innerHTML = '.lock { height: 100vh; overflow: hidden }';

  document.getElementsByTagName('head')[0].appendChild(style);

  if (type) {
    root.classList.add('lock');
  } else {
    root.classList.remove('lock');
  }
};

export const openFeedDetail = (fid) => {
  if (window.MaiMai_Native && window.MaiMai_Native.native_feed_detail && fid) {
    window.MaiMai_Native.native_feed_detail(fid);
  }
};

/**
 *
 * @param title       标题
 * @param hint        提示内容
 * @param okText     确定按钮
 * @param cancelText 取消按钮
 * @param callback    function(result){//result:0.取消，1.确定
 */
export const alert = ({
  title = '提示',
  hint = '',
  okText = '确定',
  cancelText = '取消',
  callback = 'window.console.log',
} = {}) => {
  if (window.MaiMai_Native && window.MaiMai_Native.alert) {
    window.MaiMai_Native.alert(JSON.stringify({ title, hint, okText, cancelText, callback }));
  }
};

/**
 * 上传图片
 * @param info     = {}
 * @param callback = f => f
 */
export const nativeUploadImage = (info, callback) => {
  /**
   * 回调参数
   * {
   *  tfeed_id,
   *  id,
   *  ysize,
   *  uid,
   *  thumb_size,
   *  gossip_id,
   *  turl,
   *  priv,
   *  url,
   *  stype,
   *  path,
   *  feed_id,
   *  type,
   *  treated_ysize,
   *  treated_xsize,
   *  result,
   *  xsize,
   *  img_type,
   *  message_id,
   * }
   */
  window.uploadImageCallback = callback;

  if (window.MaiMai_Native && window.MaiMai_Native.native_upload_image) {
    window.MaiMai_Native.native_upload_image(JSON.stringify(info), 'window.uploadImageCallback');
  }
};

export const hideShare = () => {
  if (window.MaiMai_Native && window.MaiMai_Native.appMsg) {
    window.MaiMai_Native.appMsg(
      JSON.stringify({
        share_info: {
          keep_default_items: 65536,
          hide_share: 'true',
        },
      })
    );
  }
};
